var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-box",on:{"click":_vm.handleJumpIndex}},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/logo.png"),"alt":"logo"}}),_c('span',{staticClass:"text"},[_vm._v("友虹文档中台")])])
}
var staticRenderFns = []

export { render, staticRenderFns }